import { Dialog, Grid, Typography, Link } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';
import SvgIconStyle from '~/components/SvgIconStyle';
import DialogTitle from '~/components/lists/dialog-title';
import useListDialogs from '~/hooks/useListDialogs';
import useLocales from '@hooks/useLocales';
import useCurrentUser from '~/hooks/useCurrentUser';
import { styles } from './styles';
import { SUPPORT_EMAIL } from '~/config';

const InsufficientCreditsDialog: FC = () => {
  const { insufficientCreditsOpened, closeInsufficientCreditsDialog, selectedIds } =
    useListDialogs();
  const { currentUser } = useCurrentUser();
  const { t } = useLocales();

  return (
    <Dialog open={insufficientCreditsOpened} onClose={closeInsufficientCreditsDialog}>
      <Grid direction="row" container rowSpacing="16px" sx={styles.dialogContainer}>
        <Grid item xs={12}>
          <DialogTitle
            onClose={closeInsufficientCreditsDialog}
            title={t('opportunities:search_results.review_credits.title')}
          />
        </Grid>
        <Grid xs={1}>
          <Box sx={styles.icon}>
            <SvgIconStyle src={'/icons/ic_bag.svg'} sx={styles.imageIcon} />
          </Box>
        </Grid>
        <Grid xs={10}>
          <Typography variant="subtitle1">{`${t(
            'opportunities:search_results.review_credits.total_credits'
          )} ${selectedIds.length}`}</Typography>
        </Grid>
        <Grid xs={10.7}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t('opportunities:search_results.review_credits.credits_per_item')}
          </Typography>
        </Grid>
        <Grid item xs={10.7} sx={styles.selectedItems}>
          <Typography variant="body2">
            {t('opportunities:search_results.review_credits.selected_items', {
              count: selectedIds.length,
            })}
          </Typography>
          <Typography variant="body2" sx={{ color: '#AA2553', paddingTop: '6px' }}>
            {t('opportunities:search_results.review_credits.insufficient_credits')}
          </Typography>
        </Grid>
        <Grid direction="row" container rowSpacing="16px" ml="44px" mt="16px">
          <Grid item xs={10}>
            <Typography variant="body1">
              {t('opportunities:search_results.review_credits.credit_balance')}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body1" sx={{ color: '#AA2553' }}>
              {currentUser?.attributes.credits_amount || 0}
            </Typography>
          </Grid>
          <Grid item xs={10} pb="16px" sx={styles.borderLine}>
            <Typography variant="body1">
              {t('opportunities:search_results.review_credits.credit_used')}
            </Typography>
          </Grid>
          <Grid item xs={0.7} pb="16px" sx={styles.borderLine}>
            <Typography variant="body1" sx={{ color: '#AA2553' }}>
              {/* TODO: add calculation based on default price for 1 sync */}-{selectedIds.length}
            </Typography>
          </Grid>
          <Grid item xs={10} pb="16px">
            <Typography variant="subtitle1">
              {t('opportunities:search_results.review_credits.credit_remaining')}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle1" sx={{ color: '#AA2553' }}>
              {currentUser?.attributes.credits_amount
                ? currentUser?.attributes.credits_amount - selectedIds.length
                : 0 - selectedIds.length}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={11.2}>
          {/* <Typography sx={styles.disclaimer}>
            {t('opportunities:search_results.review_credits.disclaimer')}{' '}
            <Link
              href={`mailto:${SUPPORT_EMAIL}`}
              sx={{ color: 'primary.main', textDecoration: 'none' }}
            >
              {SUPPORT_EMAIL}
            </Link>
            .
          </Typography> */}
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default InsufficientCreditsDialog;
